@if (node() && formGroup()) {
<div class="endpoint-panel">
    <form class="endpoint-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden"><a class="tab-link" (click)="onClick(tab)"
                        [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a></li>
                }
            </ul>
        </div>
        <div class="body">
            <div class="row">
                <div class="accordion">
                    <app-expansion [status]="model().custome.expansionRequest" [meta]="metaExpansionRequest">
                        <app-request [model]="node()!.data" [formGroup]="formGroup()!"></app-request>
                    </app-expansion>
                    <app-expansion [status]="model().custome.expansionGlossary" [meta]="metaExpansionGlossary">
                        <app-glossary [model]="node()!.data" [meta]="metaGlossary"
                            [formGroup]="formGroup()!"></app-glossary>
                    </app-expansion>
                    <app-expansion [status]="model().custome.expansionBody" [meta]="metaExpansionBody">
                        <app-request-body [model]="node()!.data" [formGroup]="formGroup()!"></app-request-body>
                    </app-expansion>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
}
